import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CiEdit } from "react-icons/ci";
import { IoNavigateCircleOutline } from "react-icons/io5";
import { LuCalendar, LuFactory, LuHistory } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../components/container/TableTitleContainer";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import routing from "../../routing";
const DPP_List = ({ title, subtitle, getPassports, published = true, pending = true, edit = true, history = true }) => {
  const { t } = useTranslation();
  const { setSelectedProducts } = useContextProvider();
  const [passports, setPassports] = useState([]);
  const navigate = useNavigate();
  const goToProductDPP_Edit = (id) => {
    setSelectedProducts([{ id }]);
    navigate(routing.sector.products.digital_passport);
  };
  const goToProductDPPHistory = (id) => {
    setSelectedProducts([{ id }]);
    navigate(routing.digital_passport.history);
  };
  const goToDDP_ViewPublished = (id) => {
    const hostingUrl = `${routing.root}${routing.digital_passport.view_published}/${id}`;
    window.open(hostingUrl, "_blank");
  };
  const goToDDP_ViewPending = (id) => {
    const hostingUrl = `${routing.root}${routing.digital_passport.view_pending}/${id}`;
    window.open(hostingUrl, "_blank");
  };
  const goToDDP_EditPending = (product_id, dpp_id) => {
    setSelectedProducts([{ id: product_id }]);
    const hostingUrl = `${routing.root}${routing.digital_passport.edit_pending}/${dpp_id}`;
    window.open(hostingUrl, "_blank");
  };
  const iconButtonCustomize = (title, Icon, onClick) => (
    <Tooltip title={title}>
      <span>
        <IconButton
          onClick={onClick}
          sx={{
            color: "#166534",
            "&:hover": { backgroundColor: "rgba(23, 163, 74, 0.2)" },
          }}>
          <Icon />
        </IconButton>
      </span>
    </Tooltip>
  );
  const editButton = (onClick) => iconButtonCustomize("Edit", CiEdit, onClick);
  const historyButton = (onClick) => iconButtonCustomize(t("History"), LuHistory, onClick);
  const navigatePublishButton = (onClick) => iconButtonCustomize("Navigate", IoNavigateCircleOutline, onClick);
  const navigatePendingButton = (onClick) => iconButtonCustomize("Navigate", IoNavigateCircleOutline, onClick);
  useEffect(() => {
    getPassports()
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPassports(data);
        } else {
          setPassports([]);
        }
      });
  }, [getPassports]);
  useEffect(() => console.log(passports), [passports]);
  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{title}</Typography>
        </TableTitleContainer>
        <TableHeaderToolsContainer>
          <Box sx={{ backgroundColor: "rgba(23, 163, 74, 0.2)", marginTop: 0.2, marginBottom: "auto", paddingX: 1.5, paddingY: 0.5, borderRadius: 4, alignItems: "center" }}>
            <Typography sx={{ color: "#166534", fontFamily: "Poppins" }}>{passports.length} Items</Typography>
          </Box>
        </TableHeaderToolsContainer>
      </TableHeaderContainer>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, paddingX: 2, paddingBottom: 2 }}>
        {passports.map((p, i) => (
          <Box
            key={i}
            sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", border: 1, borderColor: "lightgray", borderRadius: 3, paddingX: 3, paddingY: 1.5 }}>
            <Box>
              <Box>
                <Typography sx={{ textAlign: "left", color: "black", fontFamily: "Poppins", fontSize: "20px", fontWeight: 500 }}>{p?.product_name}</Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <Box>
                    <LuFactory />
                  </Box>
                  <Box>
                    <Typography>{p?.manufacturer_name}</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <Box>
                    <LuCalendar />
                  </Box>
                  <Box>
                    <Typography>{new Date(p?.last_updated.split(" GMT")[0]).toISOString().split("T")[0]}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", flex: 1, justifyContent: "flex-end" }}>
              <Box>
                <Typography sx={{ color: "black", fontFamily: "Poppins" }}>
                  {p?.carbon_footprint_value} {p?.carbon_footprint_unit}
                </Typography>
              </Box>
              <Box>
                <Typography>{p?.product_id}</Typography>
              </Box>
              <Box sx={{ display: published ? "block" : "none" }}>{navigatePublishButton(() => goToDDP_ViewPublished(p.id))}</Box>
              <Box sx={{ display: pending ? "block" : "none" }}>{navigatePendingButton(() => goToDDP_ViewPending(p._id))}</Box>
              <Box sx={{ display: edit ? "block" : "none" }}>
                {editButton(() => {
                  if (published) goToProductDPP_Edit(p.id);
                  else if (pending) goToDDP_EditPending(p.id, p._id);
                })}
              </Box>
              <Box sx={{ display: history ? "block" : "none" }}>{historyButton(() => goToProductDPPHistory(p.id))}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};
export default DPP_List;
